import React from "react";
import MemberAreaFooter from "../components/MemberAreaFooter";
import { Link } from "react-router-dom";
import { ArrowLeft, Crown } from "lucide-react";

export default function MemberUpgrade() {
  return (
    <><main className="min-h-screen bg-black px-6 py-16 text-white">
      <div className="mx-auto max-w-2xl text-center">
        <Crown className="mx-auto mb-6 text-purple-400" size={48} />
        <h1 className="mb-4 text-3xl font-bold">Membership upgrades</h1>
        <p className="mb-8 text-zinc-400">
          Member checkout is coming soon. Your current free-tier access remains available.
        </p>
        <Link
          to="/members/free"
          className="inline-flex items-center gap-2 rounded-lg border border-zinc-700 px-5 py-3 text-zinc-200 hover:border-purple-400"
        >
          <ArrowLeft size={18} />
          Back to free content
        </Link>
      </div>
    </main><MemberAreaFooter/></>
  );
}
